export const Metrics = {
    ViewEmailForm: 'View Email First Email Section',
    ViewPasswordForm: 'View Email First Password Section',
    ClickGoogle: 'Click Google Single Sign On Button',
    ClickFacebook: 'Click Facebook Single Sign On Button',
    ClickApple: 'Click Apple Single Sign On Button',
    ClickCreateAccount: 'Click Create Account Link',
    ClickForgotPassword: 'Click Forgot Password Link',
};
